module.exports = __webpack_public_path__ + "static/media/expert-logo.1d8b95e2.svg";